import { css } from '@emotion/react';
import { ThemeType } from 'types';

export const stylesInit = (theme: ThemeType) => ({
  body: css`
    display: flex;
    flex-direction: column;
    max-height: 62vh;
    min-height: 180px;
  `,
  list: css`
    flex: 1 1 auto;
    overflow-y: auto;
    padding-right: 6px;
    margin-right: -6px;
    display: flex;
    flex-direction: column;
  `,
  state: css`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 40px 0;
    color: ${theme['grey-50']};

    svg {
      width: 28px;
      height: 28px;
      opacity: 0.6;
    }
  `,
  item: css`
    display: flex;
    gap: 12px;
    padding: 16px 4px;

    & + & {
      border-top: 1px solid ${theme['grey-80']};
    }
  `,
  avatar: css`
    flex-shrink: 0;
    background-color: ${theme['purple-100']};
    color: ${theme['grey-white']};
    font-size: 13px;
  `,
  content: css`
    flex: 1;
    min-width: 0;
  `,
  head: css`
    display: flex;
    align-items: baseline;
    gap: 8px;
  `,
  author: css`
    color: ${theme['grey-white']};
    font-weight: 600;
    font-size: 13px;
    text-transform: capitalize;
  `,
  date: css`
    color: ${theme['grey-50']};
    font-size: 12px;
  `,
  actions: css`
    margin-left: auto;
    display: flex;
    gap: 10px;
    flex-shrink: 0;

    button {
      display: inline-flex;
      align-items: center;
      padding: 0;
      border: none;
      background: transparent;
      cursor: pointer;
      line-height: 0;

      svg {
        width: 15px;
        height: 15px;
      }
    }

    button.edit {
      color: ${theme['grey-white']};
    }

    button.edit:hover {
      color: ${theme['grey-30']};
    }

    button.danger {
      color: ${theme['red-100']};
    }

    button.danger:hover {
      color: ${theme['red-125']};
    }
  `,
  text: css`
    color: ${theme['grey-20']};
    font-size: 14px;
    line-height: 1.5;
    margin-top: 4px;
    white-space: pre-wrap;
    word-break: break-word;
  `,
  edit: css`
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;

    /* Match the displayed comment text size so editing looks identical. */
    .ant-input {
      font-size: 14px;
      line-height: 1.5;
    }
  `,
  editButtons: css`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  `,
  composer: css`
    display: flex;
    gap: 8px;
    align-items: flex-end;
    padding-top: 16px;
    margin-top: 4px;
    border-top: 1px solid ${theme['grey-80']};

    .ant-input {
      flex: 1;
    }
  `
});
